import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const addServicesToForm = (values, form) => ({
  form,
  type: ReservationModalActions.AddServicesToForm,
  values,
})

export { addServicesToForm }
